// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2g4D0","loaderOuter":"PageOverlayLoader_loaderOuter__2M99k"};